import { render, staticRenderFns } from "./ProgressImg.vue?vue&type=template&id=2fc768bd&scoped=true&"
import script from "./ProgressImg.vue?vue&type=script&lang=js&"
export * from "./ProgressImg.vue?vue&type=script&lang=js&"
import style0 from "./ProgressImg.vue?vue&type=style&index=0&id=2fc768bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc768bd",
  null
  
)

export default component.exports